<template>
    <kgr-lightbox
        :value="show"
        :headline="$t('Zahlungseingangsdatum setzen')"
        scrollable
        @post-input="$emit('close')"
    >
        <div class="kgr-row">
            <kgr-form-row
                :label="$t('Eingangsdatum')"
                :error="error"
                field-name="appliedAt"
            >
                <kgr-date-picker
                    :model-value="appliedAt"
                    @update:model-value="$emit('update:appliedAt', $event)"
                />
            </kgr-form-row>
        </div>
        <template #footer>
            <button
                class="kgr-button"
                @click="$emit('close')"
            >
                {{ $t('cancel') }}
            </button>
            <button
                class="kgr-button kgr-button--accent"
                @click="$emit('confirm')"
            >
                {{ $t('Ok') }}
            </button>
        </template>
    </kgr-lightbox>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker.vue';
import FormRow from '../../common/form/FormRow.vue';
import Lightbox from '../../common/modal/Lightbox.vue';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-lightbox': Lightbox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        appliedAt: {
            type: String,
            required: true,
        },
        error: {
            type: Object,
            required: true,
        },
    },
    emits: ['close', 'confirm', 'update:appliedAt'],
}
</script>
